import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadingManager } from "../loadingManager";
import { LOADING_TYPES } from "../constants";

/**
 * Shows NProgress top bar on route transitions.
 * Mount once inside Router (App.jsx).
 */
export default function RouteLoadingListener() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);
  const taskId = useRef(null);

  useEffect(() => {
    if (prevPath.current === location.pathname) return undefined;

    prevPath.current = location.pathname;
    taskId.current = loadingManager.startLoading({
      type: LOADING_TYPES.NAVIGATION,
      message: "Loading page…",
    });

    const done = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (taskId.current) {
          loadingManager.stopLoading(taskId.current);
          taskId.current = null;
        }
      });
    });

    return () => {
      cancelAnimationFrame(done);
      if (taskId.current) {
        loadingManager.stopLoading(taskId.current);
        taskId.current = null;
      }
    };
  }, [location.pathname]);

  return null;
}
